export default "__VITE_ASSET__D5BwyEHP__"